import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Table, Button, Input, Spin } from 'antd'
import UploadFile from '../CreateCancellationRequest/UploadFile'
import { files, cancellationRequests } from '@services/api'
import download from '@utils/download'
import { fileExt } from '@texts/files'
import MessageContent from './MessageContent'
import { alertPopup } from '@utils/popup'

@inject((store: any) => {
    const { popupStore, cancellationRequestStore, authStore } = store
    return {
        popupStore,
        cancellationRequestStore,
        authStore
    }
})
@observer
export default class CancellationRequestMessages extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            msgText: '',
            data: [],
            showUpload: false,
            fileData: null,
            spinner: false
        }
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    sendMessage = () => {
        const {
            popupStore: { info },
            cancellationRequestStore: { updateListLocally }
        } = this.props

        if (!this.state.msgText.trim()) return

        let payload = {
            requestId: info.id,
            message: this.state.msgText
        }

        this.setState({ spinner: true }, () => {
            cancellationRequests
                .updateCancellationRequest(payload)
                .then(res => {
                    // Single mechanism: local patch only. Clear the input only on success.
                    updateListLocally({ request: res.data.cancellation_request })
                    this.setState({ spinner: false, msgText: '' })
                })
                .catch(error => {
                    this.setState({ spinner: false })
                    this.props.cancellationRequestStore.refreshOnConflict(error)
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'העדכון נכשל' })
                })
        })
    }

    handleTextInput = e => {
        this.setState({ msgText: e.target.value })
    }

    downloadFile = async file => {
        try {
            const downloadedFile = await files
                .assert(file.url)
                .then(res => new Blob([res.data], { type: fileExt[file.file_ext] }))
            download(downloadedFile)
        } catch (e) {
            alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'הורדת הקובץ נכשלה' })
        }
    }

    uploadFile = () => {
        const { fileData } = this.state
        const {
            popupStore: { info }
        } = this.props

        if (!fileData) return

        files
            .upload(fileData.formData, { ...fileData.details, related: info.id })
            .then(res => {
                const file = JSON.stringify(res.data)
                return cancellationRequests.updateCancellationRequest({
                    requestId: info.id,
                    file
                }).then(updateRes => {
                    return { file, updateRes }
                })
            })
            .then(({ file, updateRes }) => {
                const { cancellationRequestStore, popupStore } = this.props
                cancellationRequestStore.updateListLocally({ request: updateRes.data.cancellation_request })
                popupStore.updateInfo({ ...info, file })
                cancellationRequestStore.getCancellationRequests()
                alertPopup({ type: 'success', title: 'הקובץ הועלה בהצלחה', body: '' })
            })
            .catch(error => {
                this.props.cancellationRequestStore.refreshOnConflict(error)
                alertPopup({ type: 'error', title: 'העלאת הקובץ נכשלה', body: '' })
            })
            .then(() => {
                this.setState({ fileData: null, showUpload: false })
            })
    }

    safeParse = (value, fallback) => {
        if (!value) return fallback
        if (typeof value !== 'string') return value
        try {
            return JSON.parse(value)
        } catch (e) {
            return fallback
        }
    }

    getRowKey = (record, index) => record.id || `${record.created_at || 'message'}-${index}`

    columns = [
        {
            title: 'תאריך',
            key: 'created_at',
            align: 'right',
            width: '101px',
            render: (_, record) => <div>{record.created_at}</div>
        },
        {
            title: 'ע״י',
            key: 'created_by',
            align: 'right',
            width: '60px',
            render: (_, record) => {
                const createdBy = record.created_by || {}
                return createdBy.full_name ? (
                    <div>{`${createdBy.full_name}`}</div>
                ) : (
                    <div>{`${createdBy.first_name || ''} ${createdBy.last_name || ''}`}</div>
                )
            }
        },
        {
            title: () => <span style={{ paddingRight: '10px' }}>תוכן</span>,
            key: 'msg',
            align: 'right',
            width: '295px',
            render: (_, record) => <MessageContent entry={record} />
        }
    ]

    render() {
        const {
            popupStore,
            cancellationRequestStore: { list },
            authStore: { roles }
        } = this.props
        const { info, popupType } = popupStore
        const { msgText, showUpload, fileData } = this.state
        const safeRoles = roles || []

        let data = []
        let item = list.find(({ id }) => id === info.id)
        if (item) {
            const parsedMessages = this.safeParse(item.messages, { messages: [] })
            data = (parsedMessages.messages || [])
                .map(item => this.safeParse(item, null))
                .filter(Boolean)
                .sort((a, b) => (a.updated_at > b.updated_at ? 1 : -1))
        }
        const attachedFile = this.safeParse(info.file, null)

        return (
            <Modal
                className="cancellation-req-msg-popup"
                title={info.title}
                visible={popupType === 'CancellationRequestMessages'}
                onCancel={this.closePopup}
                footer={null}
                width="600px"
            >
                <Table columns={this.columns} dataSource={data} rowKey={this.getRowKey} pagination={{ pageSize: 10 }} scroll={{ y: 300 }} />
                {(safeRoles.includes('admin') ||
                    safeRoles.includes('moderator') ||
                    safeRoles.includes('money') ||
                    safeRoles.includes('agents_moderator') ||
                    !!info.userIsRecipient) && (
                    <>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            {attachedFile && (
                                <Button
                                    style={{ alignSelf: 'end', position: 'relative', top: '-48px' }}
                                    onClick={() => this.downloadFile(attachedFile)}
                                >
                                    {'הורדת קובץ מצורף'}
                                </Button>
                            )}

                            {!attachedFile && (
                                <div style={{ alignSelf: 'end', position: 'relative', top: '-48px' }}>
                                    {!showUpload && (
                                        <Button
                                            style={{ marginLeft: '0' }}
                                            onClick={() => this.setState({ showUpload: true })}
                                        >
                                            {'צירוף קובץ'}
                                        </Button>
                                    )}

                                    {showUpload && (
                                        <Button
                                            style={{ marginLeft: '0' }}
                                            onClick={() => this.setState({ showUpload: false, fileData: null })}
                                        >
                                            {'ביטול צירוף קובץ'}
                                        </Button>
                                    )}
                                </div>
                            )}

                            {showUpload && (
                                <div style={{ display: 'flex', marginBottom: '30px' }}>
                                    <div style={{ flexGrow: '8' }}>
                                        <UploadFile setFileData={fileData => this.setState({ fileData })} />
                                    </div>
                                    {fileData && (
                                        <Button
                                            onClick={this.uploadFile}
                                            style={{ flexGrow: '1', marginLeft: '0', height: '54px' }}
                                        >
                                            {'יש ללחוץ להעלאה'}
                                        </Button>
                                    )}
                                </div>
                            )}

                            <Input.TextArea
                                autosize={{ minRows: 2, maxRows: 3 }}
                                onChange={this.handleTextInput}
                                value={msgText}
                            />
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    alignSelf: 'center',
                                    marginTop: '20px'
                                }}
                            >
                                <Button onClick={this.sendMessage}>{'הוסף הודעה'}</Button>
                                <div style={{ width: '20px' }}>{this.state.spinner && <Spin />}</div>
                            </div>
                        </div>
                    </>
                )}
            </Modal>
        )
    }
}
